module.exports = __webpack_public_path__ + "img/icon_mso_new_license_2022_00.96f6ad1d.png";